import React from 'react';

function DemoDisclaimerModal({ onAccept }) {
  return (
    <div style={overlayStyle}>
      <div style={boxStyle}>
        <h2 style={{ marginTop: 0 }}>Welcome to Adyantam Building Circle® App</h2>
        <p>This is a test version for demo purposes only — not the final app.</p>
        <p>Data shown here is for testing only and may be reset or deleted at any time.</p>
        <p>We are not collecting or storing any personal/real information in this demo.</p>
        <p><strong>Please do not enter real passwords, real payment details, or sensitive information.</strong></p>
        <button style={buttonStyle} onClick={onAccept}>
          I Understand
        </button>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const boxStyle = {
  backgroundColor: '#fff',
  borderRadius: '10px',
  padding: '24px',
  maxWidth: '400px',
  width: '90%',
  textAlign: 'left',
  boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
};

const buttonStyle = {
  marginTop: '12px',
  padding: '10px 20px',
  backgroundColor: '#25D366',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  fontWeight: 'bold',
  cursor: 'pointer',
  width: '100%',
};

export default DemoDisclaimerModal;